// Términos del piloto dentro del panel: el titular acepta por la administración, cada
// usuario reconoce el aviso y un asociado espera a que acepte el titular. Hasta entonces
// no se ve el chat (el backend tampoco responde: 428).
import React, { useState } from 'react';
import { Box, Button, Checkbox, Collapse, Text, VStack } from '@chakra-ui/react';
import { useAsistente } from './AsistenteContext';
import MensajeMarkdown from './MensajeMarkdown';

const TerminosAsistente = () => {
  const { terminos, aceptarTerminos } = useAsistente();
  const [marcado, setMarcado] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState('');
  const [verCompletas, setVerCompletas] = useState(false);
  if (!terminos) return null;

  if (terminos.pendiente === 'administracion') {
    return (
      <VStack align="stretch" spacing={3}>
        <Text fontWeight="semibold" fontSize="sm">
          Asistente en prueba
        </Text>
        <Text fontSize="sm" color="gray.600">
          El titular de tu administración todavía no aceptó las condiciones del asistente. Cuando las acepte, vas a
          poder usarlo.
        </Text>
      </VStack>
    );
  }

  const titular = terminos.pendiente === 'titular';
  const aceptar = async () => {
    setEnviando(true);
    setError('');
    try {
      await aceptarTerminos(titular ? 'titular' : 'usuario');
      setMarcado(false);
    } catch {
      setError('No se pudo registrar la aceptación. Probá de nuevo.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <VStack align="stretch" spacing={3}>
      <Text fontWeight="semibold" fontSize="sm">
        {titular ? 'Condiciones del piloto del asistente' : 'Antes de empezar'}
      </Text>
      <Box borderWidth="1px" borderRadius="md" p={3} maxH={titular ? '55vh' : 'none'} overflowY="auto" fontSize="sm">
        <MensajeMarkdown texto={terminos.texto} />
      </Box>
      {!titular && terminos.texto_titular && (
        <Box>
          <Button size="xs" variant="link" onClick={() => setVerCompletas((v) => !v)}>
            {verCompletas ? 'Ocultar las condiciones completas' : 'Ver las condiciones completas'}
          </Button>
          <Collapse in={verCompletas} animateOpacity>
            <Box mt={2} borderWidth="1px" borderRadius="md" p={3} maxH="40vh" overflowY="auto" fontSize="xs">
              <MensajeMarkdown texto={terminos.texto_titular} />
            </Box>
          </Collapse>
        </Box>
      )}
      <Checkbox size="sm" isChecked={marcado} onChange={(e) => setMarcado(e.target.checked)}>
        {titular ? 'Acepto estas condiciones en nombre de la administración.' : 'Entendido.'}
      </Checkbox>
      {error && (
        <Text fontSize="xs" color="red.500">
          {error}
        </Text>
      )}
      <Button size="sm" colorScheme="blue" isDisabled={!marcado} isLoading={enviando} onClick={aceptar}>
        {titular ? 'Aceptar' : 'Continuar'}
      </Button>
      <Text fontSize="10px" color="gray.400">
        Se registran tu usuario, la fecha y la versión del texto ({terminos.version}).
      </Text>
    </VStack>
  );
};

export default TerminosAsistente;
